<template>
  <div class="loginInternal">
    <div class="login-form mt-5">
      <div class="pt-5 pb-5">
        <form action="javascript:void(0)" class="border">
          <h2 class="text-center">Login</h2>
          <div class="form-group has-error">
            <input
              v-model="email"
              type="email"
              class="form-control"
              name="username"
              placeholder="Username"
              required="required"
            />
          </div>
          <div class="form-group">
            <input
              v-model="pass"
              type="password"
              class="form-control"
              name="password"
              placeholder="Password"
              required="required"
            />
          </div>
          <div class="form-group">
            <button
              @click="getTokenFromNode"
              type="submit"
              class="btn btn-primary btn-lg btn-block"
            >
              Sign in
            </button>
            <div v-if="error == 'load'" class="spinner-grow mt-3" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <h4 v-if="error.length > 4" class="text-danger">{{ error }}</h4>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import mixinConnection from "../../mixins/mixinsConnection";
export default {
  name: "loginInternal",
  data: () => ({
    node_send: process.env.VUE_APP_NODE_LAB,
    email: "",
    pass: "",
    error: "",
  }),

  mixins: [mixinConnection],
  methods: {
    getTokenFromNode: function() {
      this.error = "load";
      let url = "signin";
      let type = "POST";
      let credential = {
        email: this.email,
        password: this.pass,
      };
      this.nodeConection(url, type, credential)
        .then((response) => {
          var key = response.data.token;
          window.$cookies.set("ACC_KEY", key);
          this.userPriviledgeLogin(credential);
        })
        .catch((error) => {
          this.error = error.response.data.message;
        });
    },

    dec2hex(dec) {
      return dec.toString(16).padStart(2, "0");
    },

    generateAdminIdAccess(len) {
      var arr = new Uint8Array((len || 40) / 2);
      window.crypto.getRandomValues(arr);
      return Array.from(arr, this.dec2hex).join("");
    },

    userPriviledgeLogin(userData) {
      this.bladeApi("/login", "POST", userData)
        .then(async (response) => {
          if (
            ["SUPER_ADMIN", "DATA_MANAGER"].includes(response.data.data.role)
          ) {
            await window.$cookies.set("ACCESS_PRV", response.data.data.token);
            await window.$cookies.set(
              "KEY_SHA",
              this.generateAdminIdAccess(20)
            );
            await this.$router.push({ path: "/internal-dashboard/search/" });
          } else {
            window.$cookies.remove("ACC_KEY");
            this.$router.push({ name: "userDashboardSearch" });
          }
        })
        .catch((error) => {
          this.error = error.response.data.data.message;
        });
    },
  },
  created() {
    if (
      window.$cookies.get("ACC_KEY") &&
      window.$cookies.get("ACCESS_PRV") &&
      window.$cookies.get("KEY_SHA")?.length
    ) {
      this.$router.push({ path: "/internal-dashboard/search/" });
    }
  },
};
</script>
<style>
.form-control {
  min-height: 41px;
  background: #f2f2f2;
  box-shadow: none !important;
  border: transparent;
}
.form-control:focus {
  background: #e2e2e2;
}
.form-control,
.btn {
  border-radius: 2px;
}
.login-form {
  width: 350px;
  margin: 30px auto;
  text-align: center;
}
.login-form h2 {
  margin: 10px 0 25px;
}
.login-form form {
  color: #7a7a7a;
  border-radius: 3px;
  margin-bottom: 15px;
  background: #fff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  padding: 30px;
}
.login-form .btn {
  font-size: 16px;
  font-weight: bold;
  background: #3598dc;
  border: none;
  outline: none !important;
}
.login-form .btn:hover,
.login-form .btn:focus {
  background: #2389cd;
}
.login-form a {
  color: #fff;
  text-decoration: underline;
}
.login-form a:hover {
  text-decoration: none;
}
.login-form form a {
  color: #7a7a7a;
  text-decoration: none;
}
.login-form form a:hover {
  text-decoration: underline;
}
</style>
